import type { ReactElement } from 'react'

import {
  CalendarIcon,
  DollarShinyIcon,
  HandshakeIcon,
  NotebookHouseIcon,
  PeopleGraphIcon,
  PersonChartIcon
} from 'components/new-icons'

export type HomeRenovationBenefit = {
  id: string
  order: number
  icon: ReactElement
  title: string
  description: string
}

const iconColor = 'var(--colors-blue-icon-default)'

export const homeRenovationBenefits: HomeRenovationBenefit[] = [
  {
    id: 'complete-renovation',
    order: 0,
    icon: <CalendarIcon color={iconColor} />,
    title: 'Faça a reforma de uma só vez',
    description: 'Desembolso rápido para impulsionar seu planejamento.'
  },
  {
    id: 'free-use',
    order: 1,
    icon: <DollarShinyIcon color={iconColor} />,
    title: 'Use o dinheiro como quiser',
    description: 'De R$ 50 mil a R$ 25 milhões para usar como quiser.'
  },
  {
    id: 'custom-analysis',
    order: 2,
    icon: <PersonChartIcon color={iconColor} />,
    title: 'Análise personalizada por quem entende',
    description: 'Inclua quantas garantias precisar e consiga o valor ideal para o seu projeto.'
  },
  {
    id: 'human-service',
    order: 3,
    icon: <HandshakeIcon color={iconColor} />,
    title: 'Atendimento consultivo e humanizado',
    description: 'Especialistas financeiros te acompanham do começo ao fim.'
  },
  {
    id: 'income-flexibility',
    order: 4,
    icon: <PeopleGraphIcon color={iconColor} />,
    title: 'Flexibilidade na composição de renda',
    description: 'Pode incluir quantas pessoas precisar para compor a operação.'
  },
  {
    id: 'online-process',
    order: 5,
    icon: <NotebookHouseIcon color={iconColor} />,
    title: 'Processo 100% on-line e descomplicado',
    description: 'Consiga o crédito que você precisa sem sair de casa.'
  }
]
